<template>
  <v-layout row>
    <v-flex md12>
      <v-card>
        <v-toolbar dense primary-title>
          <v-toolbar-title>
            {{$t('view.perfil.registros.label')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
            <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
        <v-card-text v-show="view.elem.showTable">
          <v-layout row class="table-responsive">
            <v-flex md12>
              <table id="something" class="table table-striped table-bordered table-hover dataTables-example responsive" style="width:100%;" >
                <thead>
                  <tr>
                    <th class="all">{{$t('view.global.common.clave')}}</th>
                    <th class="all">{{$t('view.comercio.numeroComercio')}}</th>
                    <th class="all">{{$t('view.comercio.name')}}</th>
                    <th class="desktop">{{$t('view.comercio.tipoArchivo')}}</th>
                    <th class="all">{{$t('view.global.th.accion.text')}}</th>
                  </tr>
                </thead>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import ComercioAPI from "@/services/generales/comercio";
import {handleResponseMessage} from '@/helpers/http-response-handler';
import tippy from 'tippy.js';
import moment from 'moment';

export default {
  data() {
    return {
      count:0
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
        }
      }
    }
  }
  , props:{
    pageLength:{
      default:10
      , type:Number
    }
    , responsive:{
      default:true
      , type:Boolean
    }
    , dom:{
      default:'<"html5buttons"B>lTfgitp'
    } 
  }
  ,methods: {
    async deleteRow(clave){
      try{
        const swalResponse = await this.$swal({
          title: this.$t('view.global.swal.disable.title')
          , text: this.$t('view.global.swal.disable.text')
          , type: this.$t('view.global.swal.disable.type')
          , showCancelButton: this.$t('view.global.swal.disable.showCancelButton')
          , confirmButtonColor: this.$t('view.global.swal.disable.confirmButtonColor')
          , cancelButtonColor: this.$t('view.global.swal.disable.cancelButtonColor')
          , confirmButtonText: this.$t('view.global.swal.disable.confirmButtonText')
          , cancelButtonText: this.$t('view.global.swal.disable.cancelButtonText')
          , reverseButtons: true
        });
        if(swalResponse.value){
          const response = await ComercioAPI.disable({clave});
          handleResponseMessage({response: response,modulo:'Comercio'});
        }
      }catch(error){
        console.log(error)
      }
    }
    , refreshData(){
      this.dataTable._fnAjaxUpdate();
    }
  }
  , computed:{}
  , components: {}
  // Instance Lifecycle Hooks
  , created(){

  }
  , mounted(){
    const vm = this;
    function emitEventDeleteRow(event){
      const {id} = this;
      vm.deleteRow(id)
      .then(response=>{
        vm.dataTable._fnAjaxUpdate();
      })
      .catch(console.log);
    }
    function emitEventEditRow(event){
      const {id} = this;
      vm.$emit('editRow', id);
    };
    function emitEventAuditRow(event){
      const {audit,dataDescripcion} = this;
      vm.$emit('auditRow', audit,dataDescripcion);
    };

    function emitEventUnLockRow(event){
      const {id} = this;
      vm.$emit('unLockRow', id);
    };

    function emitEventSucursalRow(event){
      const {id} = this;
      vm.$emit('sucursalRow', id);
    };

    function emitAdelantarEsperaRespuesta(event){
      const {id} = this;
      console.log("emitAdelantarEsperaRespuesta");
      vm.$emit('adelantarEsperaRespuestaRow', id);
    };

    function emitCambiarFechaEsperaRespuesta(event){
      const {id} = this;
      console.log("emitCambiarFechaEsperaRespuesta");
      vm.$emit('cambiarFechaEsperaRespuestaRow', id);
    };

    function newDeleteButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Desactivar");
      button.classList.add('btn', 'btn-action-delete', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-trash-o');
      //label settings
      label.appendChild(document.createTextNode('delete'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newEditButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Editar");
      button.classList.add('btn', 'btn-action-edit', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-pencil');
      //label settings
      label.appendChild(document.createTextNode('edit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newAuditButton(id,dataDescripcion,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Auditoría");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.audit = id || "";
      button.dataDescripcion = dataDescripcion || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-database');
      //label settings
      label.appendChild(document.createTextNode('audit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };

    function newUnLockButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Desbloquear Espera Respuesta");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'mdi', 'mdi-lock-open');
      //label settings
      label.appendChild(document.createTextNode('unlock'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };

    function newAdelantarEsperaRespuesta(id,eventFunction){
      
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Forzar Respuesta");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'mdi', 'mdi-alarm-off');
      //label settings
      label.appendChild(document.createTextNode('adelantarRespuesta'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function cambiarFechaEsperaRespuesta(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Cambiar Fecha Espera Respuesta");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'mdi', 'mdi-alarm-plus');
      //label settings
      label.appendChild(document.createTextNode('cambiarfechaRespuesta'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };

    function newSucursalButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Sucursal");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'mdi', 'mdi-cash-multiple');
      //label settings
      label.appendChild(document.createTextNode('sucursal'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };

    this.$nextTick(function(){
      
      vm.dataTable = window.$('#something').dataTable({     
        "bProcessing": true
        , "bServerSide": true
        , "bPaginate":true
        , "pageLength" : vm.pageLength
        , "responsive": true
        , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
        , "ajax":{
          "url": "/api/comercio/list"
          , "type": "POST"
          , "async":true
          ,"headers":{
            "Authorization":`Bearer ${vm.$store.getters.getUserToken}`
          }
          , "data"    : function(data){}
          , "complete": function(response){}
          , "error"   : function(error){}
        }
        , "fnRowCallback": function( nRow, aData, iDisplayIndex, iDisplayIndexFull ) {
          nRow.cells[4].textContent = null;
          if(vm.$userPermission.hasPermission('ROLE_ACCESO_COMERCIO'))
            nRow.cells[4].appendChild(newEditButton(nRow.cells[0].innerText, emitEventEditRow));
          if(aData.status && vm.$userPermission.hasPermission('ROLE_DESACTIVAR_COMERCIO'))
            nRow.cells[4].appendChild(newDeleteButton(nRow.cells[0].innerText, emitEventDeleteRow));
          if(vm.$userPermission.hasPermission('ROLE_ACCESO_AUDITORIA'))
            nRow.cells[4].appendChild(
              newAuditButton(nRow.cells[0].innerText, aData['name'] , emitEventAuditRow));
          if(aData.esperaRespuesta && vm.$userPermission.hasPermission('ROLE_DESBLOQUEAR_COMERCIO'))
            nRow.cells[4].appendChild(newUnLockButton(aData.clave, emitEventUnLockRow))
          if(aData.multipleSucursal && vm.$userPermission.hasPermission('ROLE_AGREGAR_COMERCIO,ROLE_MODIFICAR_COMERCIO'))
            nRow.cells[4].appendChild(newSucursalButton(aData.clave, emitEventSucursalRow))
          if(aData.esperaRespuesta && vm.$userPermission.hasPermission('ROLE_EXTENDER_TIEMPO'))
            if(aData.fechaFinEsperaRespuesta != null ){
             nRow.cells[4].appendChild(cambiarFechaEsperaRespuesta(aData.clave, emitCambiarFechaEsperaRespuesta))            
              
              //console.log(aData.fechaFinEsperaRespuesta)
              // console.log(moment().diff(aData.fechaFinEsperaRespuesta, 'minutes'))
            }
          if(aData.esperaRespuesta && vm.$userPermission.hasPermission('ROLE_ADELANTAR_RESPUESTA_CORREO'))
            if(aData.fechaFinEsperaRespuesta != null && moment().diff(aData.fechaFinEsperaRespuesta, 'minutes') < 0  ){
             nRow.cells[4].appendChild(newAdelantarEsperaRespuesta(aData.clave, emitAdelantarEsperaRespuesta))
                            
            }
            
           
              
        }
        , "fnDrawCallback": function (oSettings) {
          tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
        }
        , "aoColumns": [
          {
            "data":"clave"
            , "sClass":"text-center"
          }
          , {
            "data":"numeroComercio"
            , "sClass":"text-center"
          } 
          , {
            "data":"name"
            , "sClass":"text-center"
          }          
          , {
            "data":"tipoArchivo"
            , "sClass":"text-center"
          }
          , {
            "data":"status"
            , "sClass":"text-center"
          }
        ]
        , "aoColumnDefs":[
          {
            "aTargets": [ 4 ],
            "mData": "status",
            "searchable": false,
            "sorting": false,
            "orderable": false,
            "width": "100",
            "mRender": function ( data, type, full ) {
              return data;
            }
          }
        ]
      });

      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/views/generales/comercio/DataTable.vue